import React from 'react';
import { Box, Tabs, Tab } from '@material-ui/core';
import Event from '../../models/Event';
import { CreatorReportAnalytics } from '../../analytics/CreatorReportAnalytics';
import AIInsightsFeaturebasedV1 from './AIInsightsFeaturebasedV1';

const AIInsightsSection = ({ event, responses, stats, isAIInsightsEnabled, user, isSummaryView, currentQuestionNumber, handleQuestionSelect }) => {
  // First check if AI Insights is globally enabled
  if (!isAIInsightsEnabled) return null;

  const eventId = Event.getId(event);

  return (
    <Box>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
        <Tabs 
          value="feature-based" 
          aria-label="AI Analysis Type"
        >
          {/* <Tab value="traditional" label="Traditional Analysis" /> */}
          <Tab value="feature-based" label="Enhanced Analysis" />
        </Tabs>
      </Box>

      <AIInsightsFeaturebasedV1
        eventId={eventId}
        isSummaryView={isSummaryView}
        questionNumber={currentQuestionNumber}
        onQuestionSelect={handleQuestionSelect}
      />
    </Box>
  );
};

export default AIInsightsSection;
